import { configureStore } from '@reduxjs/toolkit';

import { azimuthApi } from 'api/azimuth.api';
import { dashboardApi } from 'api/dashboard.api';
import { tiltApi } from 'api/tilt.api';
import { solarOportunityApi } from 'api/solarOportunity.api';

import { setupListeners } from '@reduxjs/toolkit/dist/query';
import {
  useSelector as rawUseSelector,
  TypedUseSelectorHook,
} from 'react-redux';

import { monthGenerationApi } from 'api/monthGeneration.api';

import { authMiddleware } from './middlewares/auth.middleware';

import { reducers } from './reducers';

const store = configureStore({
  reducer: reducers,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authMiddleware,
      azimuthApi.middleware,
      monthGenerationApi.middleware,
      solarOportunityApi.middleware,
      tiltApi.middleware,
      dashboardApi.middleware
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useSelector: TypedUseSelectorHook<RootState> = rawUseSelector;
setupListeners(store.dispatch);

export default store;
